import { FaPrint } from "react-icons/fa";
import { getHeaderHtml } from "../../../../util/headerUtil";
import i18n from "i18next";

export const printBillReceipt = (patientData, createdBill, totalBill, amountReceived, outstandingAmount, billingDate, paymentType,
  txnNo, authCtx, billId) => {
  const t = i18n.t.bind(i18n);
  const hospitalData = authCtx?.hospitalData || authCtx || {};
  const printWindow = window.open("", "_blank", "width=900,height=650");
  if (!printWindow) return;

  printWindow.document.write(`
    <html>
      <head>
        <title>${t("Bill Receipt")}</title>
        <style>
          body { font-family: 'Arial', sans-serif; margin: 0; padding: 20px; color: #000; }
          .header-container { text-align: center; }
          .separator { height: 1.5px; background: #000; margin: 10px 0; }
          .patient-info { display: flex; justify-content: space-between; margin-bottom: 10px; font-size: 13px; font-weight: bold; }
          .info-left { text-align: left; }
          .info-right { text-align: right; }
          .info-row { display: flex; justify-content: space-between; padding: 2px 0; }
          
          table { width: 100%; border-collapse: collapse; margin-top: 5px; }
          th, td { border: 1px solid #000; padding: 5px; text-align: left; font-size: 12px; }
          th { background: transparent; font-weight: bold; }
          .total-row td { font-weight: bold; text-align: right; }
          
          .summary-section { display: flex; justify-content: space-between; margin-top: 15px; font-size: 13px; font-weight: bold; }
          .payment-info { margin-top: 10px; font-size: 13px; font-weight: bold; }
          
          .footer-sign { margin-top: 80px; float: right; width: 250px; text-align: center; }
          .sig-line { border-top: 1px solid #000; margin-bottom: 5px; }
          @media print {
            body { padding: 10px; }
            .footer-sign {
              position: fixed;
              bottom: 20mm;
              right: 14mm;
              margin-top: 0;
            }
          }
        </style>
      </head>
      <body>
        <div class="header-container">
          ${getHeaderHtml(hospitalData)}
        </div>
        <div class="separator"></div>
        
        <div class="patient-info">
          <div style="width: 60%;">
            <div class="info-row">
              <span>Name: ${patientData?.firstName || ""} ${patientData?.lastName || ""}</span>
            </div>
            <div class="info-row">
              <span>Address: ${patientData?.address || "-"}</span>
            </div>
          </div>
          <div style="width: 40%; text-align: right;">
            <div class="info-row" style="justify-content: flex-end;">
              <span>Bill No / ID: ${billId || "-"}</span>
            </div>
            <div class="info-row" style="justify-content: flex-end;">
              <span>Mobile: ${patientData?.mobile || "-"}</span>
            </div>
            <div class="info-row" style="justify-content: flex-end;">
              <span>Date: ${billingDate ? new Date(billingDate).toLocaleString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true }) : "-"}</span>
            </div>
          </div>
        </div>

        <table>
          <thead>
            <tr>
              <th style="width: 50px;">Sr No</th>
              <th>Expense</th>
              <th style="width: 80px;">Amount</th>
              <th style="width: 70px;">Quantity</th>
              <th style="width: 80px;">Total Amt</th>
              <th style="width: 100px;">Discount(%)</th>
              <th style="width: 90px;">Net Amt</th>
            </tr>
          </thead>
          <tbody>
            ${createdBill && createdBill.length > 0
      ? createdBill.map((bill, index) => `
                <tr>
                  <td>${index + 1}</td>
                  <td>${bill.expenseName || "-"}</td>
                  <td>${Number(bill.actualAmount).toFixed(2)}</td>
                  <td>${bill.quantity ?? 1}</td>
                  <td>${(Number(bill.actualAmount) * Number(bill.quantity)).toFixed(2)}</td>
                  <td>${bill.discount ?? 0}</td>
                  <td>${Number(bill.netAmount).toFixed(2)}</td>
                </tr>`
      ).join("")
      : `<tr><td colspan="7" style="text-align:center;">${t("No Record found")}</td></tr>`
    }
            <tr class="total-row">
              <td colspan="6">Total</td>
              <td>${Number(totalBill).toFixed(2)}</td>
            </tr>
          </tbody>
        </table>

        <div class="summary-section">
          <div>Amount Received: ${Number(amountReceived).toFixed(2)}</div>
          <div>Outstanding Amount: ${Number(outstandingAmount).toFixed(2)}</div>
        </div>

        <div class="payment-info">
          Payment Type: ${paymentType || "-"}
        </div>

        <div class="footer-sign">
          <div class="sig-line"></div>
          <p style="margin: 0; font-weight: bold; font-size: 13px;">Authority Sign / Doctor Sign</p>
        </div>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();
  setTimeout(() => {
    printWindow.print();
    printWindow.close();
  }, 500);
};

const BillReceipt = ({ patientData, createdBill, totalBill, amountReceived, outstandingAmount, billingDate, paymentType,
  txnNo, authCtx, billId }) => {
  const t = i18n.t.bind(i18n);
  return (
    <button
      onClick={() => printBillReceipt(patientData, createdBill, totalBill, amountReceived, outstandingAmount, billingDate, paymentType,
        txnNo, authCtx, billId)}
      className="btn-premium mr-3"
      disabled={!billId}
      title={!billId ? t("Please submit the bill first to generate a bill number") : ""}
      style={{ opacity: !billId ? 0.6 : 1, cursor: !billId ? 'not-allowed' : 'pointer' }}
    >
      <FaPrint className="me-2" /> {t("Print Bill")}
    </button>
  );
};

export default BillReceipt;
